import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../contexts/UserContext';

const PrivetRoute = ({ children }) => {
    const { user, loading } = useContext(AuthContext);
    const location = useLocation();

    if (loading) {
        console.log('yew loading found');
        return <div>loading....</div>;
    }

    if (user && user.uid) {
        return children;
    }
    return <Navigate to={'/login'} state={{ from: location }} replace ></Navigate>;
};

export default PrivetRoute;